export enum SmartPayCustomerType {
    NewCustomer = 1,
    ExistingCustomerWithIntegration = 2,
    ExistingCustomerWithoutIntegration = 3,
}

export enum SmartPayOnboardingStatus {
    // User has no N1 integration added
    Unregistered = 1,
    // User has added the integration and stored their settings (journal, bank account), awaiting N1 email
    Pending = 2,
    // User has used their one-time password and begun onboarding
    CustomerVerifyingData = 3,
    // New customer type clicked continue onboarding while he was in CustomerVerifyingData state
    ContinuedOnboarding = 4,
    // User has completed N1 onboarding and is awaiting validation and approval by N1 and NETS
    CustomerReadyForValidation = 5,
    CustomerReadyForApproval = 6,
    // User has been validated and approved by N1 and NETS and can now make payments
    Completed = 7,
    // failure states
    Rejected = 8,
    Blocked = 9,
}

export interface SmartPayIntegrationModel {
    daybook?: number;
    paymentAccount?: number;
    feeAccount?: number;
    novemberFirstCustomerNumber: string;
    cvr: string;
    contact: string;
    telephone: string;
    email: string;
    customerType?: SmartPayCustomerType;
    status?: SmartPayOnboardingStatus;
    onboardingNfUrl: string;
}
